export default __webpack_public_path__ + "img/edit.b42fe17d.svg";